import { Component, OnDestroy, OnInit } from "@angular/core";


@Component({
    selector: "app-help-plan-types-overview",
    templateUrl: "help-plans-types-overview.component.html",
    
  })
  export class HelpPlanTypesOverviewComponent {

    constructor(
      ) { 

      } 
  }